import { MODELS } from '../Lib/constants';

export const adminsListUri = () => ({
  query: {
    id: 'adminsListForTable',
  },
  aggregate: true,
  model: MODELS.Admin,
});

export const EditAdminURI = ({ navigation }) => ({
  query: {
    model: MODELS.Admin,
    id: 'getAdminDetails',
    relationValue: {
      model: MODELS.Admin,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.Admin,
});

export const EditEmployee = ({ navigation }) => ({
  query: {
    model: MODELS.EMPLOYEE,
    id: 'getEmployeeDetails',
    relationValue: {
      model: MODELS.EMPLOYEE,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.EMPLOYEE,
});

export const employeeWithScheduleListUri = ({ filter = {} } = {}) => ({
  query: {
    id: 'employeeListsForTableWithEffectiveSchedule',
    addOnFilter: filter,
  },
  aggregate: true,
  model: MODELS.EMPLOYEE,
});
